import React, { useEffect, useState } from 'react';
import api from '../api/client';
import { useToast } from '../hooks/useToast';

const PaymentAccounts: React.FC = () => {
  const { showToast } = useToast();
  const [rows, setRows] = useState<any[]>([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get('/settings/payment-accounts').then(r => setRows(r.data.data || [])).catch(() => {}); }, []);

  const set = (i: number, k: string, v: any) => setRows(r => r.map((x, j) => j === i ? { ...x, [k]: v } : x));
  const save = async () => {
    if (rows.some(r => !String(r.label || '').trim() || !String(r.number || '').trim())) { showToast('Each account needs a name and a number', 'error'); return; }
    setSaving(true);
    try { await api.put('/settings/payment-accounts', { accounts: rows.map(r => ({ ...r, show: !!r.show })) }); showToast('Payment accounts saved'); }
    catch (e: any) { showToast(e.response?.data?.message || 'Save failed', 'error'); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Payment Accounts</h1>
        <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
      </div>
      <div style={{ fontSize: 12, color: 'var(--tx3)', marginBottom: 12 }}>
        Ticked accounts print at the bottom of invoices, receipts and repair agreements so customers know where to pay.
      </div>
      <div className="card">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr style={{ background: 'var(--sur2)' }}>
            {['Account (e.g. EVC Plus, Salaam Bank)', 'Number', 'Account name', 'Show on documents', ''].map(h =>
              <th key={h} style={{ padding: '8px 10px', fontSize: 10, fontWeight: 600, color: 'var(--tx3)', textTransform: 'uppercase', textAlign: 'left' }}>{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} style={{ borderBottom: '1px solid var(--bdr)' }}>
                <td style={{ padding: 6 }}><input className="form-control" value={r.label || ''} onChange={e => set(i, 'label', e.target.value)} /></td>
                <td style={{ padding: 6 }}><input className="form-control mono" value={r.number || ''} onChange={e => set(i, 'number', e.target.value)} /></td>
                <td style={{ padding: 6 }}><input className="form-control" value={r.holder || ''} onChange={e => set(i, 'holder', e.target.value)} placeholder="Optional" /></td>
                <td style={{ padding: 6, textAlign: 'center' }}><input type="checkbox" checked={!!r.show} onChange={e => set(i, 'show', e.target.checked)} /></td>
                <td style={{ padding: 6, width: 40 }}><button className="btn btn-secondary btn-sm" onClick={() => setRows(x => x.filter((_, j) => j !== i))}>x</button></td>
              </tr>
            ))}
            <tr><td colSpan={5} style={{ padding: 8 }}>
              <button className="btn btn-secondary btn-sm" onClick={() => setRows(x => [...x, { label: '', number: '', holder: '', show: true }])}>+ Add account</button>
            </td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default PaymentAccounts;
